export default {"src":"/_next/static/media/whatsapp.3a10a57e.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};